/*
Dilip 12/07/2022 2698947782  added data repository system notes
Saikrishna 12/08/2022 2698947782  System notes for data repo is added in popup of actions
Prakash Gummala 12/09/2022 2698947782 Fixed Table Alignment.
Akhila 12/09/2022 2698947782 Added form Notes
Ashraf 12/09/2022 2698947782 fixed notes reset issue
Dilip 12/12/2022 2698947782 changed tooltip
Ashraf 12/19/2022 2698947782 fixed notes search page break
Ashraf 12/19/2022 2698947782 fixed draggable popup issue
kavyareddy 12/20/2022 2698947782 Added dropdown for createdBy and noteType
Raghu 12/26/2022 2698947782 Removed Dialog Component
Sohel 02/13/2022 2698947782 fixed button disabled issue
Rohini 02/28/2022 2698947782 added classname for the table enhancements.
Akhila 06/07/2023 2698947782 added code and description in action
Dilip-pds 10/19/2023 2698947782 fixed created by dropdown issue
*/
import React, {createRef, useState, useEffect} from 'react';
// import MaterialTable from "material-table";
import {
  Grid,
  TablePagination,
} from '@material-ui/core';
import {tableIcons} from '../../../../../components/TableIcons';
import {httpPaginationPost} from '../../../../../util/Rest';
import {useDispatch, useSelector} from 'react-redux';
import {defaultRows} from '../../../../../constants/ReusableTablePagination';
import {Button} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import DialogBox from '../../../../../components/DialogBox';
import {
  ResetMessage as resetMessage,
  postSystemNotes,
} from '../../../../../redux/reducers/GlobalField/DataRepository';
import AddUserDefinedNotes from '../../../../../components/AddUserDefinedNotes';
import {ErrorSnackbar, SuccessSnackbar} from '../../../../../components/CustomSnackBar/index';
import GuiTable from '../../../../../components/FormComponents/GuiTable';
import {tablePageRows} from '../../../../../constants/ReusableConstants';
import {DATA_REPOSITORY} from '../../../../../constants/ReusableRoleAccess';
import SearchNotesForm from '../../../../../components/SearchNotes/searchNotesForm';

export default function DataRepositorySystemNotes({
  dialogClose,
  filedListCode,
  open,
  maxWidth,
  title,
}) {
  const moment = require('moment-timezone');

  const columns = [
    // {
    //   title: "Repository Name",
    //   field: "code",
    //   render: (rowData) => <>{rowData?.code}</>,
    // },
    {
      title: 'Note Date & Time',
      field: 'noteDate',
      type: 'datetime',
      dateSetting: {locale: 'en-US'},
      render: (rowData) => (
        <>
          {rowData?.noteDate && moment(rowData.noteDate).format('MM/DD/YYYY')}
          {` `}
          {rowData?.noteTime && moment(rowData.noteTime, 'HH:mm').format('hh:mm A')}
        </>
      ),
    },
    {
      title: 'Note Text',
      field: 'noteText',
      cellStyle: {
        // minWidth: "550px",
        wordBreak: 'break-word',
      },
      render: (rowData) => <span style={{whiteSpace: 'pre-wrap'}}>{rowData.noteText}</span>,
    },
    {
      title: 'Created by',
      field: 'userId',
    },
    {
      title: 'Note Type',
      field: 'noteType',
    },
  ];
  const {roleData} = useSelector(({role}) => role);
  const dispatch = useDispatch();
  const [arrayLast, setArrayLast] = useState(false);
  const [rows, setRows] = useState(defaultRows);
  let transcription = '';
  const tableRef = createRef();
  const [charLimitMsg, setCharLimitMsg] = useState(false);
  const [webSocketOnClose, setWebSocketOnClose] = useState();
  const [isAddaNoteDialogOpen, setAddaNoteDialogOpen] = useState(false);
  const [searchData, setSearchData] = useState({});
  const [submit, setSubmit] = useState(false);
  const dataRepoAccessAdd = !roleData?.window?.[DATA_REPOSITORY]?.['DR']?.add;
  const handleDialogClose = () => {
    stop(webSocketOnClose);
    transcription = '';
    setAddaNoteDialogOpen(false);
  };
  const handleSelectedNotesOption = () => {
    setAddaNoteDialogOpen(true);
  };
  const {isSystemNoteLoading, systemNotesStatus, notesuccessMsg, errorMsg} =
    useSelector(({dataRepository}) => dataRepository);

  // User Defined notes successfully add then after 3 sec update system notes data and reset Data (2700799562)
  useEffect(() => {
    if (systemNotesStatus === 200) {
      console.log('systemNotesStatussystemNotesStatus');
      tableRef?.current && tableRef.current.onQueryChange();
      handleDialogClose();
      // dispatch(resetNotesStatusDataRepo());
      setTimeout(() => {
        dispatch(resetMessage());
      }, 3000);
    }
  }, [systemNotesStatus]);

  useEffect(() => {
    if (submit) {
      tableRef?.current?.onQueryChange();
    }
  }, [submit, searchData]);

  // add User Defined notes(2700799562)
  const dispatchRecordFormatSystemNotes = (data) => {
    if (data) {
      dispatch(
        postSystemNotes({
          code: filedListCode ? filedListCode?.repositoryName : '',
          noteText: data,
        }),
      );
    }
  };

  return (
    // Changed Colors for Table header and body (2700799562)
    <>
      <DialogBox
        title="User Defined Notes"
        button2Text="Save"
        button1Text="Cancel"
        open={isAddaNoteDialogOpen}
        dialogClose={handleDialogClose}
        maxWidth={'md'}
      >
        {isAddaNoteDialogOpen && (
          <AddUserDefinedNotes
            transcription={transcription}
            setWebSocketOnClose={setWebSocketOnClose}
            charLimitMsg={charLimitMsg}
            isLoading={isSystemNoteLoading}
            setCharLimitMsg={setCharLimitMsg}
            dispatchRecordFormatSystemNotes={dispatchRecordFormatSystemNotes}
            disableByRoleAccess={'enable'}
          />
        )}
      </DialogBox>
      {/* <div className="custom-table global-field-table"> */}
      <Grid className="system-notes-dialog">
        <SearchNotesForm
          setSearchData={setSearchData}
          searchData={searchData}
          submit={submit}
          setSubmit={setSubmit}
          filedListCode={filedListCode}
          moduleName={'datarepository'}
        />
        <div className="custom-table  custom-toolbar-icons custom-actions-icon global-field-table new-standard-textfields">
          <GuiTable
            title=""
            columns={columns}
            icons={tableIcons}
            tableRef={tableRef}
            data={(query) =>
              new Promise((resolve) => {
                const url = `data-repository/find/all/datarepositorynotes`;
                const bodyObj = {
                  code: filedListCode ? filedListCode?.repositoryName : '',
                  limit: rows,
                  orderBy: query.orderBy && query.orderBy.field ? query.orderBy.field : '',
                  orderDirection: query.orderDirection,
                  search: '',
                  noteDate: searchData?.noteDate ?
                    moment(searchData?.noteDate).format('MM/DD/YYYY') :
                    '',
                  noteText: searchData?.noteText ? searchData?.noteText : '',
                  noteType: searchData?.noteType?.key ? searchData?.noteType?.key : '',
                  createdBy: searchData?.createdBy?.userLoginName ? searchData?.createdBy?.userLoginName : '',
                  page: submit ?
                    1 :
                    arrayLast && query?.page >= 1 ?
                      query.page :
                      arrayLast ?
                        (query.page <= 1 && query.page + 1) || query.page - 1 :
                        query.page + 1,
                };
                if (!filedListCode?.repositoryName) {
                  resolve({
                    data: [],
                    page: 0,
                    totalCount: 5,
                  });
                } else {
                  httpPaginationPost(url, bodyObj)
                    .then((response) => {
                      if (response?.status === 200) {
                        const data = response.data.response.resultObjects;
                        resolve({
                          data: data.length > 0 ? data : [],
                          page: response.data.response.page - 1,
                          totalCount: response.data.response.count,
                        });
                        setArrayLast(response.data.response.resultObjects.length === 1);
                        setSubmit(false);
                      } else {
                        resolve({
                          data: [],
                          page: 0,
                          totalCount: 5,
                        });
                        dispatch({
                          type: 'FETCH_ERROR',
                          payload: response && response.message ? response.message : null,
                        });
                      }
                    })
                    .catch((response) => {
                      resolve({
                        data: [],
                        page: 0,
                        totalCount: 5,
                      });
                      dispatch({
                        type: 'FETCH_ERROR',
                        payload: response && response.message ? response.message : null,
                      });
                    });
                }
              })
            }
            options={{
              search: false,
              pageSize: rows,
              toolbar: true,
              showSelectAllCheckbox: false,
              emptyRowsWhenPaging: false,
              pageSizeOptions: tablePageRows,
              headerStyle: {
                fontWeight: 'bold',
              },
            }}
            actions={[
              {
                icon: () => (
                  <div>
                    <Button variant="outlined" className="search-btn" disabled={dataRepoAccessAdd}>
                      <AddIcon /> Add
                    </Button>
                  </div>
                ),
                disabled: dataRepoAccessAdd,
                isFreeAction: true,
                onClick: () => handleSelectedNotesOption(),
              },
            ]}
            components={{
              Pagination: (props) => (
                <div className="global-field-table-footer">
                  <TablePagination
                    {...props}
                    SelectProps={{
                      inputProps: {'aria-label': 'Rows per screen'},
                    }}
                    rowsPerPageOptions={tablePageRows}
                    labelRowsPerPage={'Rows per screen:'}
                    onChangeRowsPerPage={(event) => {
                      props.onChangeRowsPerPage(event);
                      setRows(event.target.value);
                    }}
                  />
                </div>
              ),
            }}
          />
        </div>
      </Grid>
      {/* </div> */}
      {errorMsg && <ErrorSnackbar errorMsg={errorMsg} />}
      {notesuccessMsg && <SuccessSnackbar successMsg={notesuccessMsg} />}
    </>
  );
}
